import type { ReactNode } from 'react';
import type { PublicCatalogue } from '@ebu/contracts';
import { Button, Notice } from '@ebu/ui';
import { useI18n } from '../../i18n/i18n';
import { useGuest } from '../guest/guest-state';

/** Renders children with the current catalogue, or an honest loading / coded error state. */
export function CatalogueGate({
  children,
}: {
  children: (catalogue: PublicCatalogue) => ReactNode;
}) {
  const { catalogue, retry } = useGuest();
  const i18n = useI18n();

  if (catalogue.status === 'loading') {
    return (
      <p className="loading" role="status">
        {i18n.t('shell.loading')}
      </p>
    );
  }
  if (catalogue.status === 'error') {
    return (
      <Notice tone="error" live="assertive">
        <p>{i18n.errorMessage(catalogue.code)}</p>
        <Button variant="secondary" onClick={retry}>
          {i18n.t('error.retry')}
        </Button>
      </Notice>
    );
  }
  return <>{children(catalogue.data)}</>;
}
